// Los enlaces de antes de la conversión (contrato v2 §8) que no pueden romperse. `?regla=system:<IND>` viene
// de los correos viejos y de la tuerca vieja: si el indicador es de una alerta convertida, la lista resalta su
// fila (`resolveRuleParam`); si es de las que sólo pintan, ya no hay fila y el link abre el Tablero con la
// tuerca de esa columna, que es donde ahora se ajusta.
import {
    CURRENT_PERIOD_CPA_VS_LAST_PERIOD_CPA_COLUMN,
    CURRENT_PERIOD_CPA_VS_LAST_SIX_PERIODS_CPA_COLUMN,
    CURRENT_PERIOD_CPA_VS_LAST_THREE_PERIODS_CPA_COLUMN,
    FULL_PERIOD_BUDGET_PROPORTIONAL_COLUMN,
    FULL_PERIOD_CONVERSIONS_COLUMN,
    FULL_PERIOD_COST_VS_PROJECTED_COLUMN,
    TODAY_CLICKS_COLUMN,
    TODAY_CONVERSIONS_COLUMN,
    TODAY_COST_COLUMN,
    TODAY_CPA_COLUMN,
    TODAY_CPC_COLUMN,
    TODAY_CPM_COLUMN,
    TODAY_CTR_COLUMN,
    TODAY_IMPRESSIONS_COLUMN,
    YESTERDAY_CPA_VS_LAST_PERIOD_COLUMN,
    YESTERDAY_CPA_VS_LAST_SIX_PERIODS_CPA_COLUMN,
    YESTERDAY_CPA_VS_LAST_THREE_PERIODS_CPA_COLUMN,
} from '../dashboard/columns';
import {
    BUDGET_PROPORTIONAL_DAILY_INDICATOR,
    CONVERSIONS_DAILY_INDICATOR,
    COST_VS_PROJECTED_INDICATOR,
    CURRENT_PERIOD_CPA_VS_LAST_PERIOD_CPA,
    CURRENT_PERIOD_CPA_VS_SIX_PAST_PERIODS_CPA,
    CURRENT_PERIOD_CPA_VS_THREE_PAST_PERIODS_CPA,
    TODAY_CLICKS_INDICATOR,
    TODAY_CONVERSIONS_INDICATOR,
    TODAY_COST_INDICATOR,
    TODAY_CPA_INDICATOR,
    TODAY_CPC_INDICATOR,
    TODAY_CPM_INDICATOR,
    TODAY_CTR_INDICATOR,
    TODAY_IMPRESSIONS_INDICATOR,
    YESTERDAY_CPA_VS_LAST_PERIOD_CPA,
    YESTERDAY_CPA_VS_SIX_PAST_PERIODS_CPA,
    YESTERDAY_CPA_VS_THREE_PAST_PERIODS_CPA,
} from '../../indicators';

const FLEX_PREFIX = 'FLEX_INDICATOR||';

// La columna que pinta cada indicador que no avisa (espejo de `INDICATOR_BY_COLUMN` del backend,
// `core/presenters/columns/column_indicators.py`, sólo para los que no se convierten).
const VISUAL_ONLY_COLUMN_BY_INDICATOR = {
    [TODAY_CLICKS_INDICATOR]: TODAY_CLICKS_COLUMN,
    [TODAY_IMPRESSIONS_INDICATOR]: TODAY_IMPRESSIONS_COLUMN,
    [TODAY_COST_INDICATOR]: TODAY_COST_COLUMN,
    [TODAY_CONVERSIONS_INDICATOR]: TODAY_CONVERSIONS_COLUMN,
    [TODAY_CPC_INDICATOR]: TODAY_CPC_COLUMN,
    [TODAY_CPA_INDICATOR]: TODAY_CPA_COLUMN,
    [TODAY_CTR_INDICATOR]: TODAY_CTR_COLUMN,
    [TODAY_CPM_INDICATOR]: TODAY_CPM_COLUMN,
    [BUDGET_PROPORTIONAL_DAILY_INDICATOR]: FULL_PERIOD_BUDGET_PROPORTIONAL_COLUMN,
    [COST_VS_PROJECTED_INDICATOR]: FULL_PERIOD_COST_VS_PROJECTED_COLUMN,
    [CONVERSIONS_DAILY_INDICATOR]: FULL_PERIOD_CONVERSIONS_COLUMN,
    [CURRENT_PERIOD_CPA_VS_LAST_PERIOD_CPA]: CURRENT_PERIOD_CPA_VS_LAST_PERIOD_CPA_COLUMN,
    [CURRENT_PERIOD_CPA_VS_THREE_PAST_PERIODS_CPA]: CURRENT_PERIOD_CPA_VS_LAST_THREE_PERIODS_CPA_COLUMN,
    [CURRENT_PERIOD_CPA_VS_SIX_PAST_PERIODS_CPA]: CURRENT_PERIOD_CPA_VS_LAST_SIX_PERIODS_CPA_COLUMN,
    [YESTERDAY_CPA_VS_LAST_PERIOD_CPA]: YESTERDAY_CPA_VS_LAST_PERIOD_COLUMN,
    [YESTERDAY_CPA_VS_THREE_PAST_PERIODS_CPA]: YESTERDAY_CPA_VS_LAST_THREE_PERIODS_CPA_COLUMN,
    [YESTERDAY_CPA_VS_SIX_PAST_PERIODS_CPA]: YESTERDAY_CPA_VS_LAST_SIX_PERIODS_CPA_COLUMN,
};

/**
 * La columna del Tablero a la que lleva `?regla=system:<IND>` cuando no hay fila: la de un indicador que sólo
 * pinta, o la de una comparativa que no se convirtió (el nombre de su columna ES el indicador). `null` si el
 * link no es de una de Dashbo.
 */
export function visualOnlyColumnFor(ruleParam) {
    const text = String(ruleParam || '');
    if (!text.startsWith('system:')) return null;
    const indicator = text.slice('system:'.length);
    if (VISUAL_ONLY_COLUMN_BY_INDICATOR[indicator]) return VISUAL_ONLY_COLUMN_BY_INDICATOR[indicator];
    return indicator.startsWith(FLEX_PREFIX) ? indicator : null;
}
